module.exports = __webpack_public_path__ + "static/media/defaultUserSetting.48e13cdc.svg";